/**
 * Customer Service Module
 * API calls liên quan đến customer
 */

import * as StateManager from './state-manager.js';
import { formatDateDDMMYYYY } from './utils.js';

/**
 * Check if customer exists in ERPNext
 */
export function checkCustomerExists() {
    const $cache = StateManager.getCache();
    const phone = $cache.phone.val().trim();
    const customerExistsMsg = jQuery('#ktvhvn-customer-exists-msg');

    // Remove any existing message first
    if (customerExistsMsg.length) {
        customerExistsMsg.remove();
    }

    if (!phone) {
        return;
    }

    // Show loading state
    $cache.phone.prop('disabled', true);

    // Make AJAX request
    jQuery.post(window.ktvhvnCourseReg.ajax_url, {
        action: 'ktvhvn_check_customer_exists',
        nonce: window.ktvhvnCourseReg.nonce,
        phone: phone
    })
    .done(function(response) {
        if (response.success && response.data.exists) {
            let messageText = '';

            if (response.data.type === 'customer') {
                // Customer exists
                messageText = 'Bạn đã từng đăng ký học tại Kế Toán Việt Hưng';
            } else if (response.data.type === 'lead') {
                // Lead exists - show posting date
                const postingDate = response.data.posting_date;
                if (postingDate) {
                    // Format date from YYYY-MM-DD to DD/MM/YYYY
                    const formattedDate = formatDateDDMMYYYY(postingDate);
                    messageText = 'Bạn đã từng liên hệ để đăng ký học: ' + formattedDate;
                } else {
                    messageText = 'Bạn đã từng liên hệ để đăng ký học tại Kế Toán Việt Hưng';
                }
            }

            const message = '<div id="ktvhvn-customer-exists-msg" class="ktvhvn-customer-exists-warning">' +
                '<i class="fa fa-info-circle"></i> ' +
                messageText +
                '</div>';

            $cache.phone.after(message);
        }
    })
    .fail(function() {
        // Silent fail - don't block user if API fails
        console.log('Failed to check customer exists');
    })
    .always(function() {
        $cache.phone.prop('disabled', false);
    });
}
